import { render, staticRenderFns } from "./FamousLifeStoryWeb.vue?vue&type=template&id=fcb71f90&"
import script from "./FamousLifeStoryWeb.vue?vue&type=script&lang=js&"
export * from "./FamousLifeStoryWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports